__webpack_require__.p = "https://assets.canny.io/7900b0bf1bf4f6c4e70923e605165beae331b8ab/";